import { useEffect } from 'react';

export default () => {
  useEffect(() => {
    if (window) {
      window.location.href = 'https://duet.onelink.me/GBnZ/t3682sma';
    }
  }, []);
  return <div />;
};
